import React from "react";
import { Creatable } from "react-select";

const StylishCreatable = (props) => {
    const newStyles = {
        ...props.styles,
        menu: provided => ({ ...provided, marginTop: "2px", zIndex: 2 }),
        control: provided => ({ ...provided, boxShadow: "none" })
    };

    return (
        <Creatable
            {...props}
            styles={{ ...newStyles }}
            theme={(theme) => ({
                ...theme,
                colors: {
                    primary: "var(--lightAccentColor)",
                    primary25: "var(--selectHighlightColor)",
                    neutral0: "var(--lightMainColor)",
                    neutral20: "var(--fieldBorder)",
                    neutral30: "var(--fieldBorder)",
                    neutral80: "var(--primaryText)"
                }
            })}
        />
    );
}
export default StylishCreatable